import type { ErrorEvent as SentryErrorEvent } from '@sentry/react'

const OWN_CODE_PATH = '/assets/'

/**
 * Sentry reports everything that reaches `window.onerror`, including scripts the
 * page never asked for: browser extensions and the `WKUserScript` the native
 * shell injects. Those are tagged instead of dropped, so nothing is lost and the
 * noise can still be filtered out with `!source:external`.
 *
 * Frames are ordered outermost first, so the last one is where the error was
 * thrown. Events without a stack (a cross-origin `Script error.`) count as
 * external too — the browser hides their origin for the same reason.
 */
export const isExternalEvent = (event: SentryErrorEvent): boolean => {
  const frames = event.exception?.values?.[0]?.stacktrace?.frames
  const throwingFrame = frames?.[frames.length - 1]
  return !throwingFrame?.filename?.includes(OWN_CODE_PATH)
}
